/*
  Boitoi phone & tablet sidebar (Oct 2026). Takes over the header hamburger below 1024px and opens
  #bxs (snippets/boitoi-sidebar.liquid): slide-in panel, staggered items, accordions, a glow that
  follows the finger, live search results, swipe-left / Esc / backdrop to close, focus kept inside.
  If this file fails to load, the theme's own menu drawer still works.
*/
(function () {
  if (window.__bxSidebar) return;
  window.__bxSidebar = true;

  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var desk = window.matchMedia ? window.matchMedia('(min-width: 1024px)') : { matches: false };
  var lastFocus = null;
  var closeTimer = 0;

  function root() { return document.getElementById('bxs'); }
  function isOpen() { var r = root(); return !!(r && r.classList.contains('is-open')); }
  function burger() { return document.querySelector('.m-header__mobile .m-menu-button'); }

  function setBurger(open) {
    var b = burger();
    if (!b) return;
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function open() {
    var r = root();
    if (!r || desk.matches) return false;
    clearTimeout(closeTimer);
    lastFocus = document.activeElement;
    Array.prototype.forEach.call(r.querySelectorAll('[data-bxs-toggle]'), function (t) {
      if (!t.dataset.init) t.dataset.init = t.getAttribute('aria-expanded') || 'false';
    });
    r.hidden = false;
    var b0 = r.querySelector('[data-bxs-body]');
    if (b0) b0.scrollTop = 0;
    void r.offsetWidth;
    r.classList.add('is-open');
    document.documentElement.classList.add('bxs-lock');
    setBurger(true);
    var panel = r.querySelector('.bxs__panel');
    setTimeout(function () {
      var act = r.querySelector('.bxs__item.is-active, .bxs__subitem.is-active');
      var body = r.querySelector('[data-bxs-body]');
      if (act && body) {
        var y = act.getBoundingClientRect().top - body.getBoundingClientRect().top + body.scrollTop;
        if (y > body.clientHeight - 60) body.scrollTop = y - body.clientHeight / 2;
      }
      panel && panel.focus({ preventScroll: true });
    }, reduce.matches ? 0 : 60);
    return true;
  }

  function close(instant) {
    var r = root();
    if (!r || r.hidden) return;
    r.classList.remove('is-open', 'is-dragging');
    var panel = r.querySelector('.bxs__panel');
    if (panel) panel.style.transform = '';
    setBurger(false);
    var done = function () {
      /* start fresh next time: menu at the top, accordions as rendered, search cleared */
      Array.prototype.forEach.call(r.querySelectorAll('[data-bxs-toggle]'), function (t) {
        if (t.dataset.init) t.setAttribute('aria-expanded', t.dataset.init);
      });
      var q = r.querySelector('[data-bxs-q]');
      if (q && q.value) { q.value = ''; showResults(false); }
      var body = r.querySelector('[data-bxs-body]');
      if (body) body.scrollTop = 0;
      glowTo(null);
      r.hidden = true;
      document.documentElement.classList.remove('bxs-lock');
    };
    clearTimeout(closeTimer);
    if (instant || reduce.matches) done();
    else closeTimer = setTimeout(done, 330);
    if (lastFocus && lastFocus.focus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
  }

  /* take over the hamburger (capture phase runs before the theme's own click handler) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.m-header__mobile .m-menu-button');
    if (!b || !root() || desk.matches) return;
    e.preventDefault();
    e.stopPropagation();
    if (isOpen()) close(); else open();
  }, true);

  function prepBurger() {
    var b = burger();
    if (!b || b.__bxs || !root()) return;
    b.__bxs = true;
    b.setAttribute('role', 'button');
    b.setAttribute('tabindex', '0');
    b.setAttribute('aria-label', 'Open menu');
    b.setAttribute('aria-controls', 'bxs');
    b.setAttribute('aria-expanded', 'false');
    b.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); }
    });
  }

  /* clicks inside the sidebar */
  document.addEventListener('click', function (e) {
    var r = root();
    if (!r || !r.contains(e.target)) return;
    if (e.target.closest('[data-bxs-close]')) { e.preventDefault(); close(); return; }
    var t = e.target.closest('[data-bxs-toggle]');
    if (t) {
      e.preventDefault();
      var on = t.getAttribute('aria-expanded') !== 'true';
      t.setAttribute('aria-expanded', on ? 'true' : 'false');
      glowTo(t);
      return;
    }
    var a = e.target.closest('a[href]');
    if (a && !a.target) {
      glowTo(a.closest('.bxs__item, .bxs__subitem') || null);
      setTimeout(function () { close(true); }, 380);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var panel = root().querySelector('.bxs__panel');
    var f = Array.prototype.filter.call(panel.querySelectorAll('a[href], button, input:not([type="hidden"])'), function (el) {
      return el.offsetParent !== null && !el.closest('[hidden]');
    });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* glow that slides to the row under the finger / mouse */
  function glowTo(row, snap) {
    var r = root();
    if (!r) return;
    var body = r.querySelector('[data-bxs-body]');
    if (!body) return;
    var hl = body.querySelector('.bxs__hl');
    if (!hl) {
      hl = document.createElement('span');
      hl.className = 'bxs__hl';
      hl.setAttribute('aria-hidden', 'true');
      body.insertBefore(hl, body.firstChild);
    }
    if (!row || !body.contains(row) || row.offsetParent === null) { hl.classList.remove('is-on'); return; }
    /* layout offsets, not screen boxes, so the entrance animation does not skew the position */
    var x = 0, y = 0, n = row;
    while (n && n !== body) { x += n.offsetLeft; y += n.offsetTop; n = n.offsetParent; }
    if (snap || !hl.classList.contains('is-on') || reduce.matches) hl.style.transition = 'opacity .25s ease';
    hl.style.left = x + 'px';
    hl.style.right = 'auto';
    hl.style.width = row.offsetWidth + 'px';
    hl.style.height = row.offsetHeight + 'px';
    hl.style.transform = 'translate3d(0,' + y + 'px,0)';
    hl.classList.add('is-on');
    void hl.offsetWidth;
    hl.style.transition = '';
  }
  document.addEventListener('pointerover', function (e) {
    if (!isOpen() || e.pointerType === 'touch') return;
    var row = e.target.closest && e.target.closest('.bxs__item, .bxs__subitem');
    if (row && root().contains(row)) glowTo(row);
  });
  document.addEventListener('pointerdown', function (e) {
    if (!isOpen()) return;
    var row = e.target.closest && e.target.closest('.bxs__item, .bxs__subitem');
    if (row && root().contains(row)) glowTo(row);
  });

  /* swipe left to close */
  var drag = null;
  document.addEventListener('touchstart', function (e) {
    var r = root();
    if (!isOpen() || !r.contains(e.target) || e.touches.length !== 1) return;
    drag = { x: e.touches[0].clientX, y: e.touches[0].clientY, t: Date.now(), dx: 0, on: false };
  }, { passive: true });
  document.addEventListener('touchmove', function (e) {
    if (!drag) return;
    var dx = e.touches[0].clientX - drag.x, dy = e.touches[0].clientY - drag.y;
    if (!drag.on) {
      if (Math.abs(dx) < 10 && Math.abs(dy) < 10) return;
      if (dx > 0 || Math.abs(dy) > Math.abs(dx)) { drag = null; return; }
      drag.on = true;
      root().classList.add('is-dragging');
    }
    drag.dx = Math.min(0, dx);
    root().querySelector('.bxs__panel').style.transform = 'translate3d(' + drag.dx + 'px,0,0)';
  }, { passive: true });
  document.addEventListener('touchend', function () {
    if (!drag) return;
    var d = drag;
    drag = null;
    if (!d.on) return;
    var r = root();
    r.classList.remove('is-dragging');
    var fast = d.dx / Math.max(1, Date.now() - d.t) < -0.5;
    if (d.dx < -80 || fast) close();
    else r.querySelector('.bxs__panel').style.transform = '';
  });

  /* live search results */
  var timer = 0, ctrl = null;
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function money(p) {
    var n = parseFloat(p);
    if (isNaN(n)) return '';
    return '₹' + (n % 1 ? n.toFixed(2) : n.toLocaleString('en-IN'));
  }
  function render(q, data) {
    var r = root(), box = r.querySelector('[data-bxs-results]');
    var res = (data && data.resources && data.resources.results) || {};
    var prods = res.products || [], cols = res.collections || [];
    box.textContent = '';
    var searchUrl = (r.dataset.search || '/search') + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
    if (cols.length) {
      box.appendChild(el('p', 'bxs__rlabel', 'Collections'));
      var chips = el('div', 'bxs__chips');
      cols.slice(0, 4).forEach(function (c) { var a = el('a', 'bxs__chip', c.title); a.href = c.url; chips.appendChild(a); });
      box.appendChild(chips);
    }
    if (prods.length) {
      box.appendChild(el('p', 'bxs__rlabel', 'Books & products'));
      prods.slice(0, 6).forEach(function (p) {
        var a = el('a', 'bxs__prod');
        a.href = p.url;
        var src = (p.featured_image && p.featured_image.url) || p.image;
        if (src) {
          var img = el('img');
          img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=96';
          img.alt = '';
          img.loading = 'lazy';
          img.width = 40;
          img.height = 56;
          a.appendChild(img);
        } else a.appendChild(el('span', 'bxs__noimg'));
        var tx = el('span', 'bxs__tx');
        tx.appendChild(el('b', null, p.title));
        var pr = p.available === false ? el('small', 'is-out', 'Out of stock') : el('small', null, money(p.price));
        tx.appendChild(pr);
        a.appendChild(tx);
        box.appendChild(a);
      });
    }
    if (!prods.length && !cols.length) {
      var em = el('p', 'bxs__empty', 'No matches for “' + q + '”. ');
      var req = el('a', null, 'Request this book');
      req.href = '/pages/support?topic=book&q=' + encodeURIComponent(q);
      em.appendChild(req);
      box.appendChild(em);
    }
    var all = el('a', 'bxs__all');
    all.href = searchUrl;
    all.appendChild(el('span', null, 'See all results for “' + q + '”'));
    all.appendChild(el('span', null, '→'));
    box.appendChild(all);
  }
  function showResults(on) {
    var r = root();
    r.querySelector('[data-bxs-results]').hidden = !on;
    r.querySelector('[data-bxs-nav]').hidden = on;
    var hl = r.querySelector('.bxs__hl');
    if (hl) hl.classList.remove('is-on');
  }
  document.addEventListener('input', function (e) {
    var r = root();
    if (!r || !e.target.matches || !e.target.matches('[data-bxs-q]')) return;
    var q = e.target.value.trim();
    clearTimeout(timer);
    if (q.length < 2) { if (ctrl) ctrl.abort(); showResults(false); return; }
    timer = setTimeout(function () {
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      var url = (r.dataset.suggest || '/search/suggest') + '.json?q=' + encodeURIComponent(q) +
        '&resources%5Btype%5D=product%2Ccollection&resources%5Blimit%5D=6' +
        '&resources%5Boptions%5D%5Bunavailable_products%5D=last';
      fetch(url, { signal: ctrl ? ctrl.signal : undefined, headers: { Accept: 'application/json' } })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (data) {
          var cur = r.querySelector('[data-bxs-q]').value.trim();
          if (cur !== q) return;
          render(q, data);
          showResults(true);
        })
        .catch(function () {});
    }, 180);
  });

  /* close when the theme opens the cart or search, or when the screen becomes desktop-wide */
  function hook() {
    try {
      if (window.MinimogEvents && window.MinimogTheme && MinimogTheme.pubSubEvents) {
        MinimogEvents.subscribe(MinimogTheme.pubSubEvents.openCartDrawer, function () { isOpen() && close(true); });
        MinimogEvents.subscribe(MinimogTheme.pubSubEvents.openSearchPopup, function () { isOpen() && close(true); });
      }
    } catch (err) {}
  }
  if (desk.addEventListener) desk.addEventListener('change', function () { if (desk.matches) close(true); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) close(true); });

  function init() { prepBurger(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('load', hook);
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 0); });
})();